import { SoldProductType, ProductForSaleDTO, SoldProductDTO, SoldLotDTO, SizeDTO, ColorDTO } from 'core/api';

type SoldProductParams = {
	product: ProductForSaleDTO,
	price: number,
	lot: SoldLotDTO,
	preparationOrderId: number,
	preparationTypeId: number,
	groupName: string,
	type: SoldProductType,
	size: SizeDTO,
	color: ColorDTO
};

export function buildSoldProduct(params: SoldProductParams): SoldProductDTO {

	const { product, preparationOrderId, preparationTypeId, groupName, price, type, lot, size, color } = params;

	const soldProduct: SoldProductDTO = {
		GroupName: groupName,
		// Si el producto no lleva tipo de preparación, quitamos también el orden de preparación
		PreparationOrderId: preparationTypeId ? preparationOrderId : 0,
		PreparationTypeId: preparationTypeId,
		PriceListId: product.PriceListId,
		Price: price,
		PrintMode: product.PrintMode,
		ProductName: product.Name,
		SaleFormatId: product.SaleFormatId,
		SaleFormatName: product.SaleFormatName,
		SaleFormatRatio: product.SaleFormatRatio,
		SurchargeRate: product.SurchargeRate,
		Type: type,
		VatId: product.VatId,
		VatRate: product.VatRate,
		Lot: lot,
		Size: size,
		Color: color
	};

	return soldProduct;
}
